import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex-container" }

import { useWeb3Auth } from "@web3auth/modal-vue-composables";
// IMP START - Blockchain Calls
import RPC from "./ethersRPC";
import { ADAPTER_STATUS } from "@web3auth/base";
// import RPC from "./viemRPC";
// import RPC from "./web3RPC";
// IMP END - Blockchain Calls

export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { status, connect, userInfo, provider, logout } = useWeb3Auth();

const login = async () => {
  // IMP START - Login
  connect();
  // IMP END - Login
};

const getUserInfo = async () => {
  // IMP START - Get User Information
  uiConsole(userInfo.value);
  // IMP END - Get User Information
};

// IMP START - Blockchain Calls
const getAccounts = async () => {
  if (!provider) {
    uiConsole("provider not initialized yet");
    return;
  }
  const address = await RPC.getAccounts(provider.value!);
  uiConsole(address);
};

const getBalance = async () => {
  if (!provider) {
    uiConsole("provider not initialized yet");
    return;
  }
  const balance = await RPC.getBalance(provider.value!);
  uiConsole(balance);
};

const signMessage = async () => {
  if (!provider) {
    uiConsole("provider not initialized yet");
    return;
  }
  const signedMessage = await RPC.signMessage(provider.value!);
  uiConsole(signedMessage);
};

const sendTransaction = async () => {
  if (!provider) {
    uiConsole("provider not initialized yet");
    return;
  }
  uiConsole("Sending Transaction...");
  const transactionReceipt = await RPC.sendTransaction(provider.value!);
  uiConsole(transactionReceipt);
};
// IMP END - Blockchain Calls

function uiConsole(...args: any[]): void {
  const el = document.querySelector("#console>p");
  if (el) {
    el.innerHTML = JSON.stringify(args || {}, null, 2);
  }
  console.log(...args);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", null, [
      _createElementVNode("a", {
        target: "_blank",
        href: "https://web3auth.io/docs/sdk/pnp/web/modal",
        rel: "noreferrer"
      }, " Web3Auth "),
      _createTextVNode(" Vue Composables Modal Quick Start ")
    ], -1)),
    (_unref(status) !== _unref(ADAPTER_STATUS).CONNECTED)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "card",
          onClick: login,
          style: {"cursor":"pointer"}
        }, "Login"))
      : _createCommentVNode("", true),
    (_unref(status) === _unref(ADAPTER_STATUS).CONNECTED)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "card",
                onClick: getUserInfo,
                style: {"cursor":"pointer"}
              }, "Get User Info")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "card",
                onClick: getAccounts,
                style: {"cursor":"pointer"}
              }, "Get Accounts")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "card",
                onClick: getBalance,
                style: {"cursor":"pointer"}
              }, "Get Balance")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "card",
                onClick: signMessage,
                style: {"cursor":"pointer"}
              }, "Sign Message")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "card",
                onClick: sendTransaction,
                style: {"cursor":"pointer"}
              }, "Send Transaction")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "card",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(logout)())),
                style: {"cursor":"pointer"}
              }, "Logout")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createStaticVNode("<div id=\"console\" style=\"white-space:pre-line;\" data-v-f7f0feee><p style=\"white-space:pre-line;\" data-v-f7f0feee></p></div><footer class=\"footer\" data-v-f7f0feee><a href=\"https://github.com/Web3Auth/web3auth-pnp-examples/tree/main/web-modal-sdk/quick-starts/vue-composables-modal-quick-start\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-f7f0feee> Source code </a><a href=\"https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2FWeb3Auth%2Fweb3auth-pnp-examples%2Ftree%2Fmain%2Fweb-modal-sdk%2Fquick-starts%2Fvue-composables-modal-quick-start&amp;project-name=w3a-vue-modal&amp;repository-name=w3a-vue-modal\" data-v-f7f0feee><img src=\"https://vercel.com/button\" alt=\"Deploy with Vercel\" data-v-f7f0feee></a></footer>", 2))
  ]))
}
}

})